module.exports = "<div>\n\t<img src=\"./assets/img/pac-404.png\"/>\n  <p>{{'PaymentForm.NotFoundError' | translate}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/payment-not-found/payment-not-found.component.html
// module id = ../../../../../src/app/components/payment/payment-not-found/payment-not-found.component.html
// module chunks = main